import { Box, Button, Menu, MenuItem, Stack, Typography } from "@mui/material";
import { alpha } from "@mui/material/styles";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Globe2 } from "react-bootstrap-icons";
import { FiCheck } from "react-icons/fi";

import languages from "@locales";

const LanguageMenu = () => {
    const { i18n } = useTranslation();
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const currentCode = i18n.resolvedLanguage || i18n.language;
    const language = languages?.[currentCode] || {};

    const handleOpen = (e) => setAnchorEl(e.currentTarget);
    const handleClose = () => setAnchorEl(null);

    const handleChange = (lng) => {
        i18n.changeLanguage(lng);
        handleClose();
    };

    return (
        <>
            <Button
                onClick={handleOpen}
                aria-haspopup="true"
                aria-expanded={open}
                title="Languages"
                sx={{
                    color: 'common.white',
                    textTransform: 'uppercase',
                    fontWeight: 600,
                    fontSize: 13,
                    letterSpacing: 0.6,
                    minWidth: 0,
                    px: 1.25,
                    borderRadius: 999,
                    '&:hover': { bgcolor: (t) => alpha('#fff', 0.08) },
                }}
                startIcon={
                    language?.image ? (
                        <Box
                            component="img"
                            src={language.image}
                            alt={language.name || currentCode}
                            sx={{
                                width: 22,
                                height: 22,
                                borderRadius: '50%',
                                objectFit: 'cover',
                                boxShadow: '0 0 0 1px rgba(255,255,255,0.4)',
                            }}
                        />
                    ) : (
                        <Globe2 size={18} />
                    )
                }
            >
                {currentCode?.toUpperCase()}
            </Button>
            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                slotProps={{
                    paper: {
                        sx: { mt: 1, minWidth: 200, borderRadius: 2, boxShadow: 6 },
                    },
                }}
            >
                {Object.entries(languages).map(([lng, value]) => {
                    const active = currentCode === lng;
                    return (
                        <MenuItem
                            key={lng}
                            selected={active}
                            onClick={() => handleChange(lng)}
                            sx={{ minHeight: 44, gap: 1.5 }}
                        >
                            {value?.image && (
                                <Box
                                    component="img"
                                    src={value.image}
                                    alt={value?.name || lng}
                                    sx={{ width: 22, height: 22, borderRadius: '50%', objectFit: 'cover' }}
                                />
                            )}
                            <Stack sx={{ flexGrow: 1, minWidth: 0 }}>
                                <Typography variant="body2" sx={{ fontWeight: active ? 700 : 500 }}>
                                    {value?.native || lng}
                                </Typography>
                                <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                                    {lng.toUpperCase()}
                                </Typography>
                            </Stack>
                            {active && <FiCheck color="green" />}
                        </MenuItem>
                    );
                })}
            </Menu>
        </>
    );
};

export default LanguageMenu;
